import {Auth} from '@/database';

const state = {
    notifications: null,
    websocket: null,
    auth: null,
};

const getters = {
    allNotifications: (state) => state.notifications,
    unseenNotifications: (state) =>
        state.notifications.filter((n) => !n.seen),
};

const mutations = {
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications;
    },
    ADD_NOTIFICATION(state, notification) {
        const exists = state.notifications.find((n) => n.id === notification.id);
        if (!exists) {
            state.notifications.unshift(notification);
        }
    },
    MARK_AS_SEEN(state, notificationIds) {
        state.notifications = state.notifications.map((n) =>
            notificationIds.includes(n.id) ? { ...n, seen: true } : n
        );
    },
    MARK_AS_UNSEEN(state, notificationIds) {
        state.notifications = state.notifications.map((n) =>
            notificationIds.includes(n.id) ? { ...n, seen: false } : n
        );
    },
    SET_WEBSOCKET(state, socket) {
        state.websocket = socket;
    },
    CLOSE_WEBSOCKET(state) {
        if (state.websocket) {
            state.websocket.close();
            state.websocket = null;
        }
    },
    SET_AUTH(state, auth) {
        state.auth = auth;
    },
};

const actions = {
    async connectWebSocket({ commit, state }) {
        if (state.websocket) return; // Avoid multiple connections
        
        const auth = new Auth();
        // await auth.ensureAuthenticated();
        commit("SET_AUTH", auth);
        
        const socket = new WebSocket(
            `${auth.url.replace(/^http/, 'ws')}/notifications/ws/`
        );
        
        commit("SET_WEBSOCKET", socket);
        
        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.type === "history") {
                commit("SET_NOTIFICATIONS", data.notifications);
            } else if (data.type === "notification") {
                commit("ADD_NOTIFICATION", data.notification);
            }
        };
        
        socket.onclose = () => {
            console.log("WebSocket disconnected");
            commit("CLOSE_WEBSOCKET");
        };
        
        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };
    },
    
    disconnectWebSocket({ commit }) {
        commit("CLOSE_WEBSOCKET");
    },
    
    async getNotificationHistory({ commit, state }) {
        const auth = state.auth ?? new Auth();
        // await auth.ensureAuthenticated();
        const response = await auth.fetch('/notifications/history');
        if (response.ok) {
            const notifications = await response.json();
            commit("SET_NOTIFICATIONS", notifications);
        } else {
            const errorText = await response.text();
            console.error("Failed to fetch notification history:", errorText);
        }
    },
    
    async markAsSeen({ state, commit }, { notificationIds }) {
        const auth = state.auth ?? new Auth();
        // await auth.ensureAuthenticated();
        
        try {
            const response = await auth.fetch('/notifications/seen', {
                method: "POST",
                body: JSON.stringify({ notification_ids: notificationIds }),
            });
            
            if (response.ok) {
                commit("MARK_AS_SEEN", notificationIds);
            } else {
                const errorText = await response.text();
                console.error("Failed to mark as seen:", errorText);
            }
        } catch (error) {
            console.error("Error marking notifications as seen:", error);
        }
    },
    async markAsUnseen({ state, commit }, { notificationIds }) {
        const auth = state.auth ?? new Auth();
        // await auth.ensureAuthenticated();
        
        try {
            const response = await auth.fetch('/notifications/unseen', {
                method: "POST",
                body: JSON.stringify({ notification_ids: notificationIds }),
            });
            
            if (response.ok) {
                commit("MARK_AS_UNSEEN", notificationIds);
            } else {
                const errorText = await response.text();
                console.error("Failed to mark as unseen:", errorText);
            }
        } catch (error) {
            console.error("Error marking notifications as unseen:", error);
        }
    },
    async hideNotifications({ state, commit }, { notificationIds }) {
        const auth = state.auth ?? new Auth();
        // await auth.ensureAuthenticated();

        try {
            const response = await auth.fetch(`/notifications/hide/`, {
                method: "POST",
                body: JSON.stringify({ notification_ids: notificationIds }),
            });

            if (response.ok) {
                commit("SET_NOTIFICATIONS", state.notifications.filter(n => !notificationIds.includes(n.id)));
            } else {
                const errorText = await response.text();
                console.error("Failed to hide notification:", errorText);
            }
        } catch (error) {
            console.error("Error hiding notification:", error);
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
